import "./NotificationsButton.css"

import { useRef, useState } from "react"
import { IoMdNotificationsOutline } from "react-icons/io"

import NotificationsDrop from "@/features/pages/Notifications/NotificationsDrop/NotificationsDrop"
import { useNotificationsData } from "@/queries/queries"
import type { Notification } from "@/types/notificationTypes"
import moment from "moment"

export default function NotificationsButton() {
  const [isOpen, setIsOpen] = useState(false)
  const optionsRef = useRef(null)

  const notificationsQuery = useNotificationsData()

  // const [allNotifications] = useState<Notification[]>(
  //   notificationsQuery.data || []
  // )

  // const { authData } = useStore()
  // const userId = authData?.user?.id

  // useEffect(() => {
  //   if (!userId) return
  //   const db = getDatabase(app)
  //   const notificationsRef = ref(db, `user_notifications/${userId}`)
  //   const latestNotificationsQuery = query(notificationsRef)

  //   const unsubscribe = onValue(latestNotificationsQuery, (snapshot) => {
  //     const data = snapshot.val()
  //     if (data) {
  //       console.log("data", data)

  //       const notificationsArr = Object.entries(data)
  //         // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //         .map(([firebaseKey, value]: [string, any]) => ({
  //           ...value,
  //           firebaseKey,
  //         }))
  //         .sort((a, b) => Number(b.created_at) - Number(a.created_at))

  //       setAllNotifications((prev) => [...prev, ...notificationsArr])
  //     } else {
  //       setAllNotifications((prev) => [...prev])
  //     }
  //   })

  //   return () => {
  //     unsubscribe()
  //   }
  // }, [userId])

  const filtered = filterNotifications(notificationsQuery.data || [])

  const hasUnreadMessages = filtered.some((n) => !n.read_at)

  return (
    <div className="position-relative" ref={optionsRef}>
      {hasUnreadMessages && (
        <div
          style={{ width: "8px", height: "8px", left: "4px", top: "4px" }}
          className="position-absolute translate-middle bg-danger z-3 rounded-circle"
        ></div>
      )}
      <div className="position-relative notifications__icon__wrapper">
        <div
          className="notifications__icon"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <IoMdNotificationsOutline size={24} />
        </div>
        <NotificationsDrop
          isOpen={isOpen}
          optionsRef={optionsRef}
          realtimeData={filtered}
        />
      </div>
    </div>
  )
}

// ✅ فلترة الإشعارات
function filterNotifications(notifications: Notification[]) {
  return notifications.filter((n) => {
    if (!n.read_at) {
      return true // لسه unread
    } else {
      return !moment(n.read_at).isBefore(moment().subtract(1, "day"))
    }
  })
}
